import React from 'react';
import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';
import {GridRow} from 'components/dashboard/manager/nine-box/one-rep-chart/GridRow';
import {GraphGoal} from 'components/dashboard/manager/nine-box/NineBox.utils';

export interface GoalHoverPopupProps {
  xGoal: GraphGoal | undefined;
  yGoal: GraphGoal | undefined;
}

export const GoalHoverPopup: React.FC<GoalHoverPopupProps> = ({xGoal, yGoal}) => {
  const {root, text} = useStyles();
  const [xPrefix, yPrefix] = xGoal && yGoal ? ['X Axis ', 'Y Axis '] : [];

  return (
    <Grid container spacing={1} className={root}>
      <div className={text}>
        {xGoal && (
          <GridRow text>
            {xPrefix}Goal: {xGoal.kpi.name} ({xGoal.valueStr})
          </GridRow>
        )}
        {yGoal && (
          <GridRow text>
            {yPrefix}Goal: {yGoal.kpi.name} ({yGoal.valueStr})
          </GridRow>
        )}
      </div>
    </Grid>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
    maxWidth: 260,
  },
  text: {
    lineHeight: '24px',
    paddingRight: 8,
  },
}));
